export const FILTER_SET_CITY = 'FILTER_SET_CITY';
export const FILTER_SET_CATEGORY = 'FILTER_SET_CATEGORY';
export const FILTER_SET_DATE = 'FILTER_SET_DATE'; 
export const FILTER_RESET = 'FILTER_RESET';